import React from 'react';
import { getCommentFlagCorrectionSla } from '../../utils/workSampleCorrectionSla';

/**
 * Derived correction-SLA line for an open work-sample / portfolio flag.
 * Pure calculation from flag.created_at — no background worker.
 */
export default function FlagCorrectionSla({ flag, asOfDate = null }) {
  const sla = getCommentFlagCorrectionSla(flag, asOfDate || new Date());
  if (!sla) return null;

  const className = [
    'ws-flag-sla',
    sla.isOverdue ? 'ws-flag-sla--overdue' : '',
    sla.isDueToday ? 'ws-flag-sla--due-today' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={className} title={`Due ${sla.dueAt.toLocaleDateString()}`}>
      {sla.label}
    </span>
  );
}
